import { Component, OnInit, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-menu-page-group',
    templateUrl: './menu-page-group.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./menu-page-group.component.scss']
})
export class MenuPageGroupComponent implements OnInit {

  caption = input<string>('');
  showFavoriteIcon = input<boolean>(false)

  constructor() { }

  ngOnInit(): void {
  }

}
